import React from 'react';

const SendSMSInput: React.FC<any> = props => {
  props.close();
  return null;
};

export default SendSMSInput;
